import { inter, philosopher } from "@/lib/fonts";

interface SubmittedCardProps {
  message: string;
  onClick: () => void;
}

const SubmittedCard: React.FC<SubmittedCardProps> = ({ message, onClick }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-5 px-8">
      {/* Circular icon */}
      <div className="flex items-center justify-center w-35 h-35 rounded-full bg-[#DECEBE]/30">
        <div className="flex items-center justify-center w-28 h-28 rounded-full bg-primary shadow-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-12 h-12 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
      </div>
      <h1
        className={`text-4xl font-semibold text-secondary ${philosopher.className}`}
      >
        Mashallah!
      </h1>
      <p className={`text-center text-[#6F6F6F] ${inter.className}`}>
        {message}
      </p>
      <button
        onClick={onClick}
        className={`w-full bg-primary text-white py-2 rounded-3xl shadow-md transition hover:opacity-90 ${inter.className}`}
      >
        Great !
      </button>
    </div>
  );
};
export default SubmittedCard;
